import React from "react";
import { Box, Typography } from "@mui/material";
import { getIn } from "formik";

export default function PremiumInput({
  label,
  name,
  type = "text",
  multiline = false,
  rows = 3,
  placeholder = "",
  isRequired = false,
  formik,
  inputProps = {},
}) {
  const value = getIn(formik?.values, name) ?? "";
  const errorText = getIn(formik?.errors, name);
  const touched = getIn(formik?.touched, name);
  const isError = Boolean(touched && errorText);

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        sx={{
          color: isError ? "#ff1744" : "rgba(255,255,255,0.8)",
          fontSize: 14,
          fontWeight: 700,
          mb: 1.5,
          lineHeight: 1.6,
          transition: "color 0.3s ease",
        }}
      >
        {label}
        {isRequired && (
          <Typography component="span" sx={{ color: "#ff1744", mr: 0.5 }}>
            *
          </Typography>
        )}
      </Typography>
      <Box
        component={multiline ? "textarea" : "input"}
        type={multiline ? undefined : type}
        rows={multiline ? rows : 1}
        value={value}
        name={name}
        onChange={formik?.handleChange}
        onBlur={formik?.handleBlur}
        placeholder={placeholder}
        {...inputProps}
        sx={{
          width: "100%",
          bgcolor: "rgba(10, 10, 10, 0.6)",
          border: "1px solid",
          borderColor: isError ? "#ff1744" : "rgba(255, 255, 255, 0.1)",
          borderRadius: "12px",
          color: "#fff",
          fontSize: 15,
          fontFamily: "inherit",
          py: 1.8,
          px: 2,
          outline: "none",
          resize: "none",
          transition: "all 0.3s ease",
          boxSizing: "border-box",
          "&::placeholder": {
            color: "rgba(255, 255, 255, 0.3)",
            fontSize: 13,
          },
          "&:hover:not(:focus)": {
            borderColor: isError ? "#ff1744" : "rgba(255, 255, 255, 0.2)",
            bgcolor: "rgba(15, 15, 15, 0.8)",
          },
          "&:focus": {
            bgcolor: "rgba(0, 0, 0, 0.8)",
            borderColor: isError ? "#ff1744" : "#00ffcc",
            boxShadow: isError
              ? "0 0 0 4px rgba(255, 23, 68, 0.1)"
              : "0 0 0 4px rgba(0, 255, 204, 0.1)",
          },
        }}
      />
      {isError && (
        <Typography
          sx={{ color: "#ff1744", fontSize: 13, mt: 1, fontWeight: 500 }}
        >
          {errorText}
        </Typography>
      )}
    </Box>
  );
}
